import { Box, createStyles, Stack } from '@mantine/core';
import type { EmbeddedPromptOut } from '@repo/api-codegen';
import { memo } from 'react';
import { sanitizePromptMessage } from '../../../components/AIAssistant/utils';
import { RichEditor } from '../../../components/RichEditor';
import { PromptAttachments } from '../../AiChat/components/PromptAttachments';

const useStyles = createStyles((theme) => ({
	userMessageContainer: {
		display: 'flex',
		maxWidth: '90%',
		alignSelf: 'flex-end',
	},
	userMessageContent: {
		backgroundColor: theme.other.getColor('fill/secondary/default'),
		borderRadius: `${theme.radius.md} ${theme.radius.md} ${theme.radius.sm} ${theme.radius.md}`,
		padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
		width: '100%',
		overflow: 'auto',
	},
}));

export const UserMessage = memo(({ prompt }: { prompt: EmbeddedPromptOut }) => {
	const { classes } = useStyles();

	return (
		<Stack
			align="flex-end"
			spacing={0}
			className={classes.userMessageContainer}
		>
			<PromptAttachments message={prompt} />
			<Box className={classes.userMessageContent}>
				<RichEditor readOnly value={sanitizePromptMessage(prompt.prompt)} />
			</Box>
		</Stack>
	);
});
